import * as React from "react"
import {memo} from "react"
import {Box} from "@mui/material";
import SimpleBar from 'simplebar-react';

import 'simplebar-react/dist/simplebar.min.css';
import {scrollbarStyles, scrollbarWrapperStyles} from "./styles";


function SimpleScrollbar({ sx={}, children, ...props }) {
    const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    if (isMobile) return <Box sx={{ overflowX: 'auto', ...sx }} {...props}>
        {children}
    </Box>

    return <Box sx={scrollbarWrapperStyles}>
        <Box component={SimpleBar} clickOnTrack={false} sx={{ ...scrollbarStyles, ...sx }} {...props}>
            {children}
        </Box>
    </Box>
}

export default memo(SimpleScrollbar)